export enum ZIndex {
  Background = 0,
  Border = 1,
  Artifact = 2,
  Player = 4,
  Cursor = 5,
  TeleportMenu = 6,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  CTA = 6,
}
